import { Link } from 'react-router-dom';
import IconFavoriteBorder from '../icons/IconFavoriteBorder';
import IconSearch from '../icons/IconSearch';
import IconPodium from '../icons/IconPodium';
import IconCrown from '../icons/IconCrown';
import IconSatellite from '../icons/IconSatellite';

const CompeticionHeaderMenu = (props) => {
  const selected = props.selected || 1;

  // Si no hay competición todavía, no mostrar nada
  if (!props.competicion || !props.competicion.visible) return null;

  const { competicion } = props;

  return (
    <div className="bg-gray-900 fixed top-16 left-0 right-0 z-40">

      {/* NOMBRE DE LA COMPETICIÓN */}
      {competicion.nombre && (
        <div className="text-center pb-1 pt-3 px-4">
          <div
            className="font-montserrat font-semibold italic text-white leading-tight text-2xl truncate overflow-hidden whitespace-nowrap"
          >
            {competicion.nombre}
          </div>
        </div>
      )}

      {/* MENÚ DE NAVEGACIÓN */}
      <ul
        className="
          flex overflow-x-auto scrollbar-hide list-none mb-2 p-0
          justify-start md:justify-center md:overflow-visible pl-2 pr-2
        "
      >

        {/* Líderes */}
        <li className="flex-shrink-0">
          <Link
            to={`/competicion/${competicion.id}`}
            className={`
              flex flex-col items-center justify-center px-4 py-3 min-w-[80px]
              transition-all duration-200
              ${selected === 1
                ? 'text-red-500 drop-shadow-[0_0_6px_rgba(239,68,68,0.8)]'
                : 'text-white hover:text-gray-400'
              }
            `}
          >
            <IconPodium fill="currentColor" className="w-5 h-5 mb-1" />
            <span className="text-xs font-montserrat font-light uppercase tracking-wider">
              Líderes
            </span>
          </Link>
        </li>

        {/* Clasificación */}
        <li className="flex-shrink-0">
          <Link
            to={`/competicion/${competicion.id}/todos`}
            className={`
              flex flex-col items-center justify-center px-4 py-3 min-w-[80px]
              transition-all duration-200
              ${selected === 6
                ? 'text-red-500 drop-shadow-[0_0_6px_rgba(239,68,68,0.8)]'
                : 'text-white hover:text-gray-400'
              }
            `}
          >
            <IconPodium fill="currentColor" className="w-5 h-5 mb-1" />
            <span className="text-xs font-montserrat font-light uppercase tracking-wider">
              Clasific.
            </span>
          </Link>
        </li>

        {/* Rankings (condicional) */}
        {competicion.ranking_numero > 0 && (
          <li className="flex-shrink-0">
            <Link
              to={`/competicion/${competicion.id}/ranking`}
              className={`
                flex flex-col items-center justify-center px-4 py-3 min-w-[80px]
                transition-all duration-200
                ${selected === 2
                  ? 'text-red-500 drop-shadow-[0_0_6px_rgba(239,68,68,0.8)]'
                  : 'text-white hover:text-gray-400'
                }
              `}
            >
              <IconCrown fill="currentColor" className="w-5 h-5 mb-1" />
              <span className="text-xs font-montserrat font-light uppercase tracking-wider">
                Rankings
              </span>
            </Link>
          </li>
        )}

        {/* Favoritos */}
        <li className="flex-shrink-0">
          <Link
            to={`/competicion/${competicion.id}/favoritos`}
            className={`
              flex flex-col items-center justify-center px-4 py-3 min-w-[80px]
              transition-all duration-200
              ${selected === 3
                ? 'text-red-500 drop-shadow-[0_0_6px_rgba(239,68,68,0.8)]'
                : 'text-white hover:text-gray-400'
              }
            `}
          >
            <IconFavoriteBorder fill="currentColor" className="w-5 h-5 mb-1" />
            <span className="text-xs font-montserrat font-light uppercase tracking-wider">
              Favoritos
            </span>
          </Link>
        </li>

        {/* Buscar */}
        <li className="flex-shrink-0">
          <Link
            to={`/competicion/${competicion.id}/buscar`}
            className={`
              flex flex-col items-center justify-center px-4 py-3 min-w-[80px]
              transition-all duration-200
              ${selected === 4
                ? 'text-red-500 drop-shadow-[0_0_6px_rgba(239,68,68,0.8)]'
                : 'text-white hover:text-gray-400'
              }
            `}
          >
            <IconSearch fill="currentColor" className="w-5 h-5 mb-1" />
            <span className="text-xs font-montserrat font-light uppercase tracking-wider">
              Buscar
            </span>
          </Link>
        </li>

        {/* GPS (condicional) */}
        {competicion.mapa_geojson && competicion.trackers && competicion.trackers.length > 0 && (
          <li className="flex-shrink-0">
            <Link
              to={`/competicion/${competicion.id}/gps`}
              className={`
                flex flex-col items-center justify-center px-4 py-3 min-w-[80px]
                transition-all duration-200
                ${selected === 5
                  ? 'text-red-500 drop-shadow-[0_0_6px_rgba(239,68,68,0.8)]'
                  : 'text-white hover:text-gray-400'
                }
              `}
            >
              <IconSatellite fill="currentColor" className="w-5 h-5 mb-1" />
              <span className="text-xs font-montserrat font-light uppercase tracking-wider">
                GPS
              </span>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
}

export default CompeticionHeaderMenu;
